<template>
  <div class="market-search-results" role="dialog" aria-labelledby="marketSearchResultsTitle" aria-modal="true">
    <div class="bg" v-on:click.prevent="close"></div>
    <div class="content">
      <CloseButton ref="closeButton" @close="close" />
      <div class="intro">
        <h3 id="marketSearchResultsTitle" aria-label="Wähle deinen REWE Markt">Wähle deinen REWE Markt</h3>
        <strong
          ><span class="label">Deine ausgewählte Postleitzahl:</span>
          <span class="zip-info">{{ zip }}</span></strong
        >
      </div>
      <div class="results">
        <div class="loading" v-if="loading" role="status" aria-live="polite">Suche läuft...</div>
        <div class="no-results" v-else-if="results.length === 0" role="status" aria-live="polite">
          Die Postleitzahl scheint leider ungültig zu sein.
        </div>
        <div class="results-list" v-else>
          <h4 class="visually-hidden">{{ results.length }} Märkte gefunden</h4>
          <ul aria-label="Liste der gefundenen REWE Märkte">
            <li v-for="result in results" :key="result.id">
              <div class="market-info">
                <div class="details">
                {{ result.title }}<br />
                {{ result.address.street }}<br />
                {{ result.address.zip }} {{ result.address.city }}
              </div>
              <div class="distance">
                {{ result.address.distance | floatWithTwoDecimals }}&nbsp;km
              </div>
            </div>
            <button
              class="button-primary"
              v-on:click.prevent="selectMarket(result)"
              :aria-label="`Markt auswählen: ${result.title}`"
            >
              Markt auswählen
            </button>
          </li>
        </ul>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { ajaxGet } from "@/helpers/ajax";
import CloseButton from "@/components/CloseButton.vue";
export default {
  name: "market-search-results",
  components: { CloseButton },
  data() {
    return {
      results: []
    };
  },
  mounted() {
    this.results = [];
    this.$store.commit("SET_SHOW_SCROLLBAR", false);
    this.getMarkets();
    this.$refs.closeButton && this.$refs.closeButton.$el.focus();
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  },
  methods: {
    selectMarket(result) {
      this.$store.commit("SET_SHOW_SCROLLBAR", true);
      this.$store.commit("SET_BODY_NO_OVERFLOW", false);
      this.$router.push({
        name: "homeMarket",
        params: { nr: result.nr, slug: result.slug }
      });
    },
    getMarkets: async function() {
      // this.$store.commit("SET_LOADING", true);
      const response = await ajaxGet(`zip/${this.zip}.json`);
      this.results = response.data;
      // this.$store.commit("SET_LOADING", false);
    },
    close() {
      this.$store.commit("SET_SHOW_SCROLLBAR", true);
      this.$store.commit("SET_BODY_NO_OVERFLOW", false);
      this.$emit("close");
    }
  },
  computed: {
    ...mapState(["zip", "loading"])
  }
};
</script>

<style lang="scss">
@import "./MarketSearchResults";
</style>